/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 *
 * Primary entry point for accessing DataSets
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { globalEngine, ModuleManager } from "./Init"
import { logNormal, logInformation, logWarning, logError, logDebug, logConsole, logRawTrack, logTransports, logAutomationError } from "./bootstrap_web_ext";

// #ENDIF WebPack


// sample rule defn
//var rule1 = { "ruleName" : "inRange","meta" : { "min" : 1, "max": 5 }, "onMismatch": "invalidValue", "onError":"errorOccurred" };
//var rule2 = {	"ruleName" : "equal",	"meta" : 8};
//var rule3 = {	"ruleName" : "or",	"meta" : [rule1, rule2]};
//var rule4 = { "ruleName" : "and", "meta" : [rule1, rule2]};
//var rule5 = {	"ruleName" : "in",	"meta" : [8, 9]};
//var rule6 = {	"ruleName" : "notNull" };

function CreateRules()
{
	var rules = 
	{
		"notNull" : function(value, meta) { return (value != null); },
		"inRange" : function(value, meta) { return (value >= meta.min) && (value <= meta.max); },
		"equal" : function(value, meta) { return (value == String(meta)); },
		"greater" : function(value, meta) { return (value > meta); },
		"greaterEqual" : function(value, meta) { return (value >= meta); },
		"less" : function(value, meta) { return (value < meta); },
		"lessEqual" : function(value, meta) { return (value <= meta); },
		"notEqual" : function(value, meta) { return (value != String(meta)); },
		"startsWith" : function(value, meta) { return !value.indexOf(meta); },
		"endsWith" : function(value, meta) { return value.indexOf(meta, value.length - meta.length) !== -1; },
		"contains" : function(value, meta) { return value.indexOf(meta) !== -1; },
		"regex": function (value, meta) { 
			
			try 
			{
				var re = new RegExp(meta); 
				// New regex suport, with flags
				if (meta['expr'] && meta['flags']) {
					re = new RegExp(meta['expr'], meta['flags']); 
				} 
				return re.test(value); 
			} catch (e) {
				logWarning('rules.regex exception: ' + e.message);
				return false;
			}
		},
		"in": function (value, meta) { for (var i in meta) { if (value == String(meta[i])) return true; } return false; },
		"isType": function (value, meta) { return (typeof value === meta); },
		"isEqual": function (value,meta){return value == meta;},
		"not" : function(value, meta) 
		{
			return !(this[meta.ruleName](value, meta.meta));
		},
		"or" : function(value, meta) 
		{
			for (var i in meta)
			{
				if(this[meta[i].ruleName](value, meta[i].meta)) return true;
			}
			return false;
		},
		"and" : function(value, meta) 
		{
			for (var i in meta)
			{
				if(!this[meta[i].ruleName](value, meta[i].meta)) return false;
			}
			return true;
		},
		"date_earlier": function (value, meta) // value == date as ISO string or Date(), meta == delta in milliseconds
		{
		    var value_time = value;
		    if (typeof value === "string")
		    {
		        // convert to date 
		        value_time = new Date(value);
		    }
		    if (!(value_time instanceof Date))
		    {
		        logDebug("date_earlier: invalid input value type is '" + typeof value + "'");
		        return false; // can't compare if the input is not a date
		    }

		    var now_time = new Date();
		    logDebug("date_earlier: compare (now - value = " + (now_time - value_time) + ") < " + meta);
		    return (now_time - value_time) < meta;
		},
		"date_later": function (value, meta) // value == date as ISO string or Date(), meta == delta in milliseconds
		{
		    var value_time = value;
		    if (typeof value === "string")
		    {
		        // convert to date 
		        value_time = new Date(value);
		    }
		    if (!(value_time instanceof Date))
		    {
		        logDebug("date_later: invalid input value type is '" + typeof value + "'");
		        return false; // can't compare if the input is not a date
		    }

		    var now_time = new Date();
		    logDebug("date_later: compare (now - value = " + (now_time - value_time) + ") > " + meta);
		    return (now_time - value_time) > meta;
		},

		// Throttling rules, if it returns true means stop the event, false means send the event. 

		// Sample - random sample / probability of being sent, meta is between 0 to 1
		"sample": function(name, meta) { return Math.random() > meta; },
		"getDailyMaxTableCounter": function(profileName)
		{
		    var targetDailyMaxTable = this._dailyMaxTable[profileName];
		    if (!targetDailyMaxTable)
		    {
		        return null;
		    }

		    return targetDailyMaxTable['counter'];
		},
		// Daily - daily maximum events for each name, calculated based on a 24 hour intervals since first one
		"_dailyMaxTable": {},
		"dailyMax": function(name, meta)
		{
			// time interval, 24 hours == 86400000, this timeInterval is all that needs to be replaced if there is a weeklyMax, monthlyMax, etc.
			var timeInterval = 86400000;
			var currentTimeMs = Date.now();

			// If this is the first one, add entry in table and send the event OR If it's been 24 hours, reset the counter and send the event
			if ((!this._dailyMaxTable[name]) || (currentTimeMs - this._dailyMaxTable[name].startTimeMs > timeInterval))
			{
				this._dailyMaxTable[name] = {
					"counter": 1,
					"startTimeMs": currentTimeMs
				};
				return false;
			}
			this._dailyMaxTable[name].counter++;

			// If it's less the limit per day, then send the event
			if (this._dailyMaxTable[name].counter < meta)
			{
				return false;
			}

			logWarning('dailyMax: reached the maximum for the day for ' + name + ', max: ' + meta + ' current: ' +
				this._dailyMaxTable[name].counter);
			return true;
		},

	    /* Evaluates if a value passes a rule
        *
        *   @param value Value to be evaluated
        *   @param ruleConfig Rules
        *
        *   @return true if passed, false otherwise or invalid ruleConfig
        */
		"evaluate": function(value, ruleConfig)
		{
		    try
		    {
		        if (!ruleConfig || !ruleConfig.ruleName)
		        {
		            return false;
		        }
		        return this[ruleConfig.ruleName](value, ruleConfig.meta);
		    }
		    catch(e)
		    {
		        logError('rules.evaluate: ' + e.message);
		        return false;
		    }
		},

		// This function is a specific version of evaluate just for event attributes
		"apply": function(value, ruleConfig)
		{
			try
			{
				if (!ruleConfig || !ruleConfig.ruleName) return value;

				// corner case rule 'override' that will return meta
				if (ruleConfig.ruleName == 'override')
				{
					// log if the override is passed something, it should be passed nothing
					if (value != null)
					{
						logWarning('Using override value: replacing ' + value + ' with ' + ruleConfig.meta);
					}
					return ruleConfig.meta;
				}

				if (this[ruleConfig.ruleName](value,ruleConfig.meta))
				{
					return value;
				}

				if (((value === undefined) || (value === null)) && ruleConfig.optional)
				{
				    return "[not assigned]";
				}

				if (ruleConfig.onMismatch === undefined)
				{
					return "[ruleMismatch]";
				}
				return ruleConfig.onMismatch;
			}
			catch(e)
			{
				if (!ruleConfig.onError)
				{
					return "[ruleError]";
				}
				return ruleConfig.onError;
			}
		}
	};
	return rules;
}

ModuleManager.registerFactory("rules", CreateRules);
//export  {CreateRules};
//globalEngine.FactoryMap["rules"] =  CreateRules;
